import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const adminOrganizationSettingsTranslationSlice = (state: RootState) =>
  state.entities.adminOrganizationSettingsTranslation;

export const adminOrganizationSettingsTranslationByIdState = selectorsFactory.createEntityStateByIdSelector(
  adminOrganizationSettingsTranslationSlice,
);

export const adminOrganizationSettingsTranslationState = selectorsFactory.createStaticKeyWindowStateMemoizedSelector(
  adminOrganizationSettingsTranslationSlice,
);

export const adminOrganizationSettingsTranslation = selectorsFactory.createStaticKeyWindowEntitiesSelector(
  adminOrganizationSettingsTranslationSlice,
);
